import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "4",
      class: "text-center"
    }, "Ngày"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      class: "text-center"
    }, "Thu hồi để thanh lý"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "4",
      class: "text-center"
    }, [
      /*#__PURE__*/_createTextVNode(" Ghi chú"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "thu-hoi-header-help" }, "(Kế toán ký đối chiếu hằng tháng)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "3",
      class: "text-center"
    }, [
      /*#__PURE__*/_createTextVNode(" Tổng số phải thu hồi"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "thu-hoi-header-help" }, "(=Cột 2-B01.b)")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "3",
      class: "text-center"
    }, "Trong đó")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center"
    }, "Mất"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center"
    }, "Thực thu hồi")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Quy đổi ra Kg")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "thu-hoi-col-index-row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "A"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "1=2+3"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "2"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "3"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "4"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "C")
  ])
], -1)
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = { class: "thu-hoi-col-text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center text-muted"
}, "Không có dữ liệu", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "text-center fw-bolder" }, "Tổng cộng", -1)
const _hoisted_12 = { class: "text-end fw-bolder" }
const _hoisted_13 = { class: "text-end fw-bolder" }
const _hoisted_14 = { class: "text-end fw-bolder" }
const _hoisted_15 = { class: "text-end fw-bolder" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "text-center text-muted py-5"
}

import { computed, PropType } from "vue";
import { formatDisplayingDate } from "@/core/hooks/use-date-time-hook";
import { formatQuantity } from "@/core/helpers/number-format";
import type { B02bRow, B02Totals } from "@/types/thu-hoi-vtpt";
import { THU_HOI_COLUMN_WIDTHS } from "./thu-hoi-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThuHoiB02bTable',
  props: {
  rows: {
    type: Array as PropType<B02bRow[]>,
    required: true,
  },
  totals: {
    type: Object as PropType<B02Totals>,
    required: true,
  },
  showEmpty: {
    type: Boolean,
    default: true,
  },
  isPrintModal: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const colW = THU_HOI_COLUMN_WIDTHS;

const tableClass = computed(() =>
  props.isPrintModal
    ? "thu-hoi-table bao-cao-table--print"
    : "table core-table thu-hoi-table"
);

const formatNgay = (ngay: string) => formatDisplayingDate(ngay, "/");

return (_ctx: any,_cache: any) => {
  return (__props.rows.length || __props.showEmpty)
    ? (_openBlock(), _createElementBlock("table", {
        key: 0,
        class: _normalizeClass(tableClass.value)
      }, [
        _createElementVNode("colgroup", null, [
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).ngay}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).soLuong}px` })
          }, null, 4),
          _createElementVNode("col", {
            style: _normalizeStyle({ width: `${_unref(colW).text}px` })
          }, null, 4)
        ]),
        _hoisted_1,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${row.ngay}-${index}`,
              class: _normalizeClass({
          'bao-cao-table-data-row': __props.isPrintModal,
          'bao-cao-table-data-row--last':
            __props.isPrintModal && index === __props.rows.length - 1,
        })
            }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(formatNgay(row.ngay)), 1),
              _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(formatQuantity)(row.tong_phai_thu_hoi)), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(formatQuantity)(row.mat)), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(formatQuantity)(row.thuc_thu_hoi_sl)), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatQuantity)(row.thuc_thu_hoi_kg)), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(row.ghi_chu), 1)
            ], 2))
          }), 128)),
          (!__props.rows.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true),
          (__props.rows.length)
            ? (_openBlock(), _createElementBlock("tr", {
                key: 1,
                class: _normalizeClass({
          'thu-hoi-table-total-row': !__props.isPrintModal,
          'bao-cao-table-total-row': __props.isPrintModal,
        })
              }, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatQuantity)(__props.totals.tong_phai_thu_hoi)), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatQuantity)(__props.totals.mat)), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatQuantity)(__props.totals.thuc_thu_hoi_sl)), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatQuantity)(__props.totals.thuc_thu_hoi_kg)), 1),
                _hoisted_16
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, "Không có dữ liệu"))
}
}

})